import { ApiService } from 'src/app/services/api/api.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSpecialsService {

  private baseUrl = environment.base_url + `users`;

  constructor(private http: HttpClient, private apiService: ApiService) {}

  createUserSpecials(specials_data): Observable<any> {
    return this.apiService.post('users/createUserSpecials', specials_data);
    // return this.http.post<any>(this.baseUrl + `/createUserSpecials`, specials_data);
  }

  updateUserSpecials(specials_data): Observable<any> {
    return this.apiService.post('users/updateUserSpecials', specials_data);
    //return this.http.post<any>(this.baseUrl + `/updateUserSpecials`, specials_data);
  }

  getUserSpecials(): Observable<any> {
    return this.apiService.get('users/getUserSpecials');
    // return this.http.get<any>(this.baseUrl + `/getUserSpecials`);
  }
}
